var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loadImageAsset, loadSceneConfig } from "./assetLoader";
export function load(input) {
    return __awaiter(this, void 0, void 0, function* () {
        const sceneConfig = yield loadSceneConfig(input);
        if (sceneConfig.documentElements.length > 1) {
            throw new Error("Multiple pages are not supported!");
        }
        const element = sceneConfig.documentElements[0];
        // Load all scene assets in parallel
        const assets = yield Promise.all([
            loadImageAsset(element.maskUrl),
            loadImageAsset(sceneConfig.backgroundImageUrl),
            loadImageAsset(sceneConfig.overlayImageUrl),
        ]);
        return {
            width: sceneConfig.width,
            height: sceneConfig.height,
            documents: [
                {
                    page: element.page,
                    width: element.width,
                    height: element.height,
                    blendingMode: element.blendingMode,
                    transform: element.transform,
                },
            ],
            mask: assets[0],
            background: assets[1],
            overlay: assets[2],
        };
    });
}
//# sourceMappingURL=sceneLoader.js.map